/**
 * Tiện ích xử lý scroll cho ứng dụng
 */

// Lấy hướng scroll hiện tại
export const getScrollDirection = (currentScrollY, lastScrollY) => {
  if (currentScrollY > lastScrollY) {
    return 'down';
  } else if (currentScrollY < lastScrollY) {
    return 'up';
  }
  return 'none';
};

// Theo dõi hướng scroll với throttling
export const useScrollDirection = (callback, thresholdPixels = 10, delay = 100) => {
  let lastScrollY = window.scrollY;
  let lastTime = Date.now();
  
  const checkScroll = () => {
    const currentScrollY = window.scrollY;
    const currentTime = Date.now();
    
    if (currentTime - lastTime < delay) {
      return;
    }
    
    if (Math.abs(currentScrollY - lastScrollY) > thresholdPixels) {
      const direction = getScrollDirection(currentScrollY, lastScrollY);
      callback(direction, currentScrollY);
      lastScrollY = currentScrollY;
      lastTime = currentTime;
    }
  };
  
  window.addEventListener('scroll', checkScroll, { passive: true });
  
  return () => {
    window.removeEventListener('scroll', checkScroll);
  };
};

// Lấy vị trí scroll hiện tại dạng phần trăm
export const getScrollPercentage = () => {
  const scrollTop = window.scrollY;
  const docHeight = document.documentElement.scrollHeight - window.innerHeight;
  return (scrollTop / docHeight) * 100;
};

// Kiểm tra xem có đang ở đầu trang không
export const isAtPageTop = (thresholdPixels = 50) => {
  return window.scrollY <= thresholdPixels;
};

// Hàm cuộn trang mượt mà
export const scrollToElement = (elementId, offset = 0) => {
  const element = document.getElementById(elementId);
  if (!element) return;
  
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.scrollY - offset;
  
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};

// Optimize scroll performance by adding a class during scroll
export const optimizeScrollPerformance = () => {
  let scrollTimeout;
  const html = document.documentElement;
  
  const handleScroll = () => {
    if (!html.classList.contains('is-scrolling')) {
      html.classList.add('is-scrolling');
    }
    
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      html.classList.remove('is-scrolling');
    }, 100); // Remove class 100ms after scrolling stops
  };
  
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  return () => {
    window.removeEventListener('scroll', handleScroll);
    if (scrollTimeout) clearTimeout(scrollTimeout);
  };
};
